export default "__VITE_ASSET__0d6de945__"